import useIsMobile from '@/hooks/useIsMobile';
import useCreateShop from './useCreateShop';
import CreateShopDesktop from './desktop';
import CreateShopMobile from './mobile';

function CreateShop() {
  const isMobile = useIsMobile(992);
  const viewModel = useCreateShop();

  return isMobile ? <CreateShopMobile viewModel={viewModel} /> : <CreateShopDesktop viewModel={viewModel} />;
}

export default CreateShop;
